import { render, staticRenderFns } from "./ForestersEstate.vue?vue&type=template&id=55cb5e98&scoped=true"
import script from "./ForestersEstate.vue?vue&type=script&lang=js"
export * from "./ForestersEstate.vue?vue&type=script&lang=js"
import style0 from "./ForestersEstate.vue?vue&type=style&index=0&id=55cb5e98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cb5e98",
  null
  
)

export default component.exports